import { cva } from 'class-variance-authority';

import s from './ScreenTitle.module.css';

export const screenTitleVariants = cva(s['screen-title'], {
  defaultVariants: {
    variant: 'default',
  },
  variants: {
    variant: {
      default: null,
      transparent: null,
    },
  },
});
